import React from "react";
import NavBar from "../Components/NavBar";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { addDoc, collection  } from "firebase/firestore";
import { firestore } from "../Firebase/config";

export default function Report() {
  const dietList = useSelector((state) => state.diet.dietList);
  const workoutPlane = useSelector((state) => state.workout.workoutPlane);
  const userId = useSelector((state) => state.user.user.docId);
  const { register, handleSubmit } = useForm();
  const weekday = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];
  const todayDate = new Date();
  const day = weekday[todayDate.getDay()];

  const todayWorkout = workoutPlane[day];

  const submitReport = async (data) => {
    // console.log(data);
    const docRef = await addDoc(
      collection(firestore, `users/${userId}/report`),
      data
    );

    // console.log(docRef);
  };
  return (
    <>
      <NavBar />

      <hr className="mt-5" />
      <h1 className="text-3xl text-center mt-3 mb-3"> Today Report </h1>
      <hr />
      <form
        className="sm:max-w-lg max-w-sm mx-auto mb-20 mt-20 gap-y-2 grid grid-cols-6"
        onSubmit={handleSubmit(submitReport)}
      >
        <input
          type="date"
          value={todayDate.toISOString().split("T")[0]}
          className="col-span-6 mx-1"
          {...register("data")}
        />

        <h2 className="col-span-6 text-3xl text-center my-4 font-bold">Diet</h2>
        {dietList.map((item) => (
          <>
            {" "}
            <label key={item.question} className=" text-xl col-span-5">
              {item.question}
            </label>
            <input type="checkbox" {...register(item.question)} />{" "}
          </>
        ))}

        <h2 className="col-span-6 text-3xl text-center my-4 font-bold capitalize">
          Workout form {day}
        </h2>

        {
          <>
            <label className=" text-xl col-span-5">{todayWorkout}</label>
            <input type="checkbox" {...register("workout")} />
          </>
        }

        <button className="text-lg p-2 bg-blue-500 mt-4 text-white rounded-md col-start-3 col-span-2">
          Submit
        </button>
      </form>
    </>
  );
}
